
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Update, GetById } from "adminApi/HallSeatPlanApi/HallSeatPlan";
import { validateForm } from "utils/validation";
import { HallSeatPlanRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditHallSeatPlanForm from "./Componates/EditHallSeatPlanForm";
import fields from "../json/HallSeatPlanFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";


const EditHallSeatPlan = () => {
  const navigate = useNavigate();
  const { formdata } = fields;
  const { id } = useParams();


  // Initialize form values from JSON fields
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, handleFileChange, setErrors, setValues } = useFormChange(
    initialValues,
    HallSeatPlanRules
  );

  // Fetch existing data by ID
  const { loading: loadingFetch } = useFetchFormDataById(
    id,
    formdata,
    GetById,
    setValues
  );

  // Form submit
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      delete formValues?.imagePreview;
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Update({ id, data: formData });
    },
    (vals) => {
      const err = validateForm(vals, HallSeatPlanRules)
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Update Hall Seat Plan successfully"
  );

  return (
    <>
      {(loadingSubmit || loadingFetch) && <Spinner isSpinner={true} />}
      <EditHallSeatPlanForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        imagePreview={values.imagePreview || values.image}
        title="Update Hall Seat Plan"
        handleFileChange={handleFileChange}
        formdata={formdata}
      />
    </>
  );
};

export default EditHallSeatPlan;
